export default __webpack_public_path__ + "static/media/GoogleSans-Regular.e5c56aa7.ttf";